import * as React from 'react';

import { Spinner } from 'app/components/common/spinner';

import styles from './logout-page.module.scss';

export const LogoutPage = () => <Spinner className={styles.spinner} />;
